// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { BootstrapLink, Link } from '../../../dsl/front'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component({
  name: 'ReadMoreLink',
  components: { BootstrapLink },

  template: `
    <BootstrapLink v-if="link && link.target" :link="link" class="read-more-link">
      {{ link.label || $t('_.see-more') }}
    </BootstrapLink>
  `
})
export class ReadMoreLink extends Vue {
  /**
   * "Read more" link.
   */
  @Prop({ type: Object, required: true })
  public readonly link!: Link
}
